import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "返回首页", icon: "ri-home-4-line" },
  { to: "/category/movie", label: "浏览日韩电影", icon: "ri-film-line" },
  { to: "/category/tv", label: "浏览日韩电视剧", icon: "ri-tv-2-line" },
  { to: "/search", label: "搜索影视作品", icon: "ri-search-line" },
];

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
      <span className="font-label text-[11px] uppercase tracking-[0.24em] text-foreground-400">Error 404</span>
      <p className="mt-4 font-heading text-6xl font-semibold text-primary-950 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
        这个页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        你访问的地址可能已经失效，或者在整理片单时被移动了位置。可以从下面重新出发。
      </p>

      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-800"
        >
          <i className="ri-arrow-left-line text-sm" />
          回到首页
        </Link>
        <Link
          to="/category/all"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          查看全部作品
        </Link>
      </div>

      <div className="mt-10 grid w-full max-w-2xl grid-cols-1 gap-3 sm:grid-cols-2">
        {quickLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="flex cursor-pointer items-center gap-3 rounded-lg border border-background-200/80 bg-background-50 px-4 py-3 text-left text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-100 text-primary-700">
              <i className={`${link.icon} text-base`} />
            </span>
            {link.label}
            <i className="ri-arrow-right-line ml-auto text-base text-foreground-400" />
          </Link>
        ))}
      </div>
    </div>
  );
}